import styled from "styled-components";

export const FooterContent = styled.footer`
  display: grid;
  height: 3rem;
  margin: auto;
  margin-top: 3rem;
  justify-content: center;
`;

export const TextArea = styled.div`
  display: flex;
  width: 25rem;
  align-items: center;
  justify-content: space-evenly;
`;

export const MyWebPage = styled.a`
  text-decoration: none;
  color: white;
`;